import { useCallback, useMemo, useRef } from 'react';
export const useBackgroundClick = (props) => {
    const isMouseDown = useRef(false);
    const isMouseUp = useRef(false);
    const backgroundProps = useMemo(() => {
        var _a;
        const { onMouseDown: onMouseDownProp, onMouseUp: onMouseUpProp, ...rest } = ((_a = props.backgroundProps) !== null && _a !== void 0 ? _a : {});
        return {
            ...rest,
            onMouseDown(e) {
                if (e.currentTarget === e.target) {
                    isMouseDown.current = true;
                }
                if (onMouseDownProp) {
                    onMouseDownProp(e);
                }
            },
            onMouseUp(e) {
                if (e.currentTarget === e.target && isMouseDown.current) {
                    isMouseDown.current = false;
                    isMouseUp.current = true;
                }
                if (onMouseUpProp) {
                    onMouseUpProp(e);
                }
            }
        };
    }, [props.backgroundProps]);
    const onBackgroundClick = useCallback((e) => {
        if (isMouseUp.current && props.onBackgroundClick) {
            props.onBackgroundClick(e);
        }
        isMouseDown.current = false;
        isMouseUp.current = false;
    }, [props.onBackgroundClick]);
    return { backgroundProps, onBackgroundClick };
};
